import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircleIcon, HomeIcon, FileTextIcon } from 'lucide-react';
export const ServiceRequestSuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    serviceName,
    referenceNumber
  } = location.state || {
    serviceName: 'Service Request',
    referenceNumber: 'REQ-000000'
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center" data-id="element-5225">
      <div className="max-w-md w-full mx-auto px-4 py-8" data-id="element-5226">
        <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm text-center" data-id="element-5227">
          <div className="flex justify-center mb-4" data-id="element-5228">
            <div className="rounded-full bg-green-100 p-3" data-id="element-5229">
              <CheckCircleIcon className="h-12 w-12 text-green-600" data-id="element-5230" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-5231">
            Request Submitted Successfully
          </h1>
          <p className="text-gray-600 mb-6" data-id="element-5232">
            Your {serviceName} request has been submitted and is being
            processed.
          </p>
          <div className="bg-gray-50 rounded-lg p-4 mb-6" data-id="element-5233">
            <p className="text-sm text-gray-500" data-id="element-5234">Reference Number</p>
            <p className="text-lg font-medium text-gray-900" data-id="element-5235">
              {referenceNumber}
            </p>
          </div>
          <div className="space-y-3" data-id="element-5236">
            <button onClick={() => navigate('/request-details', {
            state: {
              referenceNumber
            }
          })} className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700" data-id="element-5237">
              <FileTextIcon className="h-4 w-4 mr-2" data-id="element-5238" />
              View Request Details
            </button>
            <button onClick={() => navigate('/')} className="w-full inline-flex justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-5239">
              <HomeIcon className="h-4 w-4 mr-2" data-id="element-5240" />
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>;
};